import CardViewComponent from '../CardViewComponent/CardViewComponent';

import {
  Modal,
  ModalContent,
  ModalContentText,
  ModalTitle,
  Typography,
} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import './popupTableModel.css';

const PopupTableModel = (props) => {
  const {t} = useTranslation();

  const handleClose = () => {
    props.setVisible(false);
  };

  const headers =
    props?.records?.length > 0 ? Object.keys(props?.records[0]) : [];

  return (
    <Modal
      className="EquipmentViewPopup"
      open={props.visible}
      onClose={handleClose}
      aria-labelledby="alert-Modal-title"
      aria-describedby="alert-Modal-description"
      fullWidth={true}
    >
      <ModalTitle bgcolor={'#F0F0F0'} id={'alert-Modal-title'}>
        {props.title}
      </ModalTitle>
      <ModalContent>
        <ModalContentText id="alert-Modal-description">
          <div className="assetPopupContainer">
            <div className="assetPopupHeader">
              {headers.map((item) => (
                <Typography key={item}>
                  <b>{t(item)}</b>
                </Typography>
              ))}
            </div>
            <div className="">
              {props?.records?.map((item) => (
                <div className="assetPopupBody" key={item}>
                  {Object.values(item).map((i) => (
                    <Typography variant="label" key={i.value}>
                      {i.value}
                    </Typography>
                  ))}
                </div>
              ))}
            </div>
          </div>

          <div className="assetPopupContainerMobileView">
            {props.records &&
              props.records.length > 0 &&
              props.records.map((item) => (
                <CardViewComponent
                  key={'card-component'}
                  records={item}
                  className={'contractDetailSection'}
                />
              ))}
          </div>
        </ModalContentText>
        {props.secondaryElement ? props.secondaryElement : ''}
      </ModalContent>
    </Modal>
  );
};

export default PopupTableModel;
